let _env = {};
async function tryFetch(url) {
    try {
        const res = await fetch(url);
        if (res.ok)
            return (await res.json());
    }
    catch {
        // ignore
    }
    return null;
}
// /environment.local.json is a gitignored dev override; /environment.json is
// injected by CloudOS at deploy time from .cloudos/web/service_config/*/*/*.yml
export async function loadEnvironment() {
    _env = (await tryFetch('/environment.local.json')) ?? (await tryFetch('/environment.json')) ?? {};
}
export function getEnv(key) {
    return _env[key] ?? '';
}
